import { useEffect, useRef } from 'react';

export const computeDivisionDocs = (allDocs, division) => {
  const validDocs = allDocs.filter(
    (row) =>
      row.doc &&
      ['ticket', 'fieldMeet', 'standby'].includes(row.doc.docType) &&
      row
  );
  const folderIDs = division.folderIDs;
  const divisionDocs = validDocs.filter(
    (row) =>
      row.doc.pge_folderID !== null &&
      folderIDs &&
      folderIDs.indexOf(row.doc.pge_folderID) > -1
  );
  return divisionDocs;
};


export const usePrevious = (value) => {
  const ref = useRef();
  useEffect(() => {
    ref.current = value;
  }, [value]);
  return ref.current;
};

export const getFolderByID = (foldersJson, pge_folderID) => {
  const folderData = foldersJson
    ? foldersJson.find((folder) => folder.id === pge_folderID)
    : '';
  return folderData;
};

export const docLastUpdated = (obj) => {
  if (obj.doc.pge_statusUpdated && obj.doc.pge_responseType) {
    return obj.doc.metadata.date > obj.doc.pge_statusUpdated
      ? obj.doc.metadata.date
      : obj.doc.pge_statusUpdated;
  } else if (obj.doc.pge_responseType && !obj.doc.pge_statusUpdated) {
    return obj.doc.metadata.date;
  } else if (obj.doc.pge_statusUpdated) {
    return obj.doc.pge_statusUpdated;
  } else {
    return null;
  }
};

export const createNewTimeSlice = () => ({
  open: [],
  closed: [],
  digIn: [],
  duration: [],
});

export const getRawDigInDecimal = (doc) => doc?.digInRiskModel?.prediction;

// Returns a dig in risk percent between 0 and 1. -1 if invalid.
export const getDigInPercent = (dirtyDecimal) => {
  try {
    if (typeof dirtyDecimal !== 'number' && typeof dirtyDecimal !== 'string') {
      return -1;
    }

    return (100 * dirtyDecimal).toFixed(2);
  } catch (e) {
    return -1;
  }
};

export const getIsDigInRisk = (dirtyDecimal) => {
  if (process.env.REACT_APP_DIG_IN_MODEL === 'true') {
    const digInPercent = getDigInPercent(dirtyDecimal);
    if (digInPercent >= 50) return true;
  } else {
    return false;
  }
};
export const getIsManualTicket = (doc) => {
  const manualStr = doc._id.split('-')[2];
  return manualStr === 'MANUAL';
};

export const getLongDuration = (doc) => {
  return doc?.durationModel;
};
export const getPredictedDuration = (doc) => {
  let predictedMinutes = 0;
  let fourHours = 60 * 4;

  if (doc?.durationModel) {
    const { prediction } = doc.durationModel;
    switch (typeof prediction) {
      case 'number':
        predictedMinutes = Math.round(prediction);
        break;
      case 'boolean':
        predictedMinutes =
          doc.durationModel.status === 'Success' && prediction === true
            ? fourHours
            : 0;
        break;
      default:
        predictedMinutes = 0;
        break;
    }
  }
  return predictedMinutes;
};

export const getOptionsFromStandbyInspectors = (users) => {
  const options = [];
  users.map((u) => {
    const middle = `${u.user.middle_name ? ' ' + u.user.middle_name : ''}`;
    const suffix = `${u.user.suffix ? ' ' + u.user.suffix : ''}`;
    options.push({
      title: `${u.user.lan_id} - ${u.user.last_name}, ${u.user.first_name}${middle}${suffix}`,
      option_id: u.user.lan_id,
    });
  });

  return options;
};

// todo: move out to helper
export const hasValue = (val) => {
  return val.toString().replace(/\s+/g, '');
};

export const sortTicketsByDate = (tickets, isDescending) => {
  const sortedKeys = Object.keys(tickets).sort((a, b) => {
    const dateA = new Date(a.split('-').slice(3));
    const dateB = new Date(b.split('-').slice(3));
    return isDescending ? dateB - dateA : dateA - dateB;
  });

  const newObject = {};
  sortedKeys.forEach((key) => (newObject[key] = tickets[key]));
  return newObject;
};

export const mergeDigInByIndex = (featureImportanceLookup, metadata) => {
  const { actual_values, feature_importance } = metadata;
  const combinedData = [];
  for (const index in featureImportanceLookup) {
    const combinedEntry = {};
    combinedEntry.shap = feature_importance[index] || 0;
    combinedEntry.actual_value = actual_values[index] || 0;
    combinedEntry.name = featureImportanceLookup[index][0] || '';
    combinedEntry.readableName = featureImportanceLookup[index][1] || '';
    combinedData.push(combinedEntry);
  }
  return combinedData;
};

export const sortDiginByShap = (digInData) => {
  return digInData.sort((a, b) => {
    const absoluteValShapA = Math.abs(a.shap);
    const absoluteValShapB = Math.abs(b.shap);
    return absoluteValShapB - absoluteValShapA;
  });
};

export const getDigInRankMapping = (prediction) => {
  const digInRankMapping = {
    0: { color: 'green', text: 'Low (0 - 80)' },
    80: { color: '#c0c028', text: 'Medium (80 - 90)' },
    90: { color: '#e59604', text: 'High (90 - 95)' },
    95: { color: 'red', text: 'Highest (95 - 100)' },
  };
  return digInRankMapping[
    Object.keys(digInRankMapping).reduce((prevRankKey, currentRankKey) => {
      return prediction >= currentRankKey ? currentRankKey : prevRankKey;
    })
  ];
};
export const getAssociatedChannelsForId = (ticketDetail) => {
  const id = ticketDetail._id;
  let channels;
  switch (ticketDetail.doc_type) {
    case 'standby':
      channels = `standbyID-${id},ticketID-${id}`;
      break;
    case 'fieldMeet':
      channels = `fieldMeetID-${id},ticketID-${id}`;
      break;
    default:
      channels = 'ticketID-' + id;
  }
  return channels;
};
